// src/js/main/configurator.js

// --- Importer ---
import { DOMElements, initializeDOMElements } from '../config/dom.js';
import { PricingCalculator } from '../config/pricingCalculator.js';
import { adjustNumber, applyTier, resetSelection, loadConfigurationIntoForm } from '../config/configFormHandler.js';
import { saveToBrowser } from '../config/saveToBrowser.js';
import { saveToFile } from '../config/saveToFile.js';
import { deleteConfiguration } from '../config/deleteConfiguration.js';
import { proceedToOrder } from '../config/proceedToOrder.js';
import { populateConfigSelect } from '../config/ui/populateConfigSelect.js';
import { handleSelectConfigChangeUI } from '../config/ui/handleSelectConfigChangeUI.js';
import { initializeFlexView } from '../config/flexView.js';
import { processUrlParams } from '../config/urlParamHandler.js'; // <-- NY IMPORT

// Modaler
import { initializeConfirmSaveModal } from '../config/ui/confirmSaveModal.js';
import { initializePromptDeleteModal } from '../config/ui/promptDeleteModal.js';
import { initializePromptForNameModal } from '../config/ui/promptForNameModal.js';
import { initializeLoadConfigModal, showLoadConfigModal } from '../config/ui/loadConfigModal.js';

function setupEventListeners() {
    const {
        pricingTable, adjustNumberBtns, applyTierBtns, resetSelectionHeader,
        saveToBrowserBtn, saveToFileBtn, proceedToOrderBtn, deleteConfigBtn,
        openConfigBtn, selectConfig
    } = DOMElements;

    if (pricingTable) pricingTable.addEventListener('change', PricingCalculator.updatePrices);
    adjustNumberBtns.forEach(button => {
        button.addEventListener('click', () => {
            const delta = parseInt(button.dataset.delta, 10);
            adjustNumber(button, delta);
            PricingCalculator.updatePrices();
        });
    });
    applyTierBtns.forEach(button => {
        button.addEventListener('click', () => {
            const tier = button.dataset.tier;
            if (tier) applyTier(tier);
        });
    });
    if (resetSelectionHeader) resetSelectionHeader.addEventListener('click', resetSelection);
    if (saveToBrowserBtn) saveToBrowserBtn.addEventListener('click', saveToBrowser);
    if (saveToFileBtn) saveToFileBtn.addEventListener('click', saveToFile);
    if (deleteConfigBtn) deleteConfigBtn.addEventListener('click', deleteConfiguration);
    if (openConfigBtn) openConfigBtn.addEventListener('click', showLoadConfigModal);
    if (selectConfig) {
        selectConfig.addEventListener('change', (event) => {
            handleSelectConfigChangeUI(event.target.value);
        });
    }
    if (proceedToOrderBtn) {
        proceedToOrderBtn.addEventListener('click', proceedToOrder);
    }
    console.log('Event Listeners for configurator have been set up.');
}

// --- Huvud-initialisering för sidan ---
document.addEventListener('DOMContentLoaded', () => {
    console.log('Configurator page initializing...');

    initializeDOMElements();

    if (window.SimP_Page_Context?.is_flex_page === '1' && typeof window.SimP_Flex_Prices === 'object') {
        console.log('Flex page detected, merging flex prices...');
        // Slå ihop de "hemliga" priserna med standardpriserna.
        Object.assign(window.SimP.DATA.addonPricesPerUnit, window.SimP_Flex_Prices);
    }

    initializeConfirmSaveModal();
    initializePromptDeleteModal();
    initializePromptForNameModal();
    initializeLoadConfigModal();

    if (window.SimP_Page_Context?.is_flex_page === '1') {
        initializeFlexView();
    }

    populateConfigSelect();
    PricingCalculator.updatePrices();
    setupEventListeners();
    processUrlParams();

    console.log('Configurator page initialized successfully!');
});